import{formatLocale as r}from"d3-format";r({thousands:" ",grouping:[3]}).format(",.2f");var t=function(){return Math.random().toString(36).substr(2,10)};export{t as getUnicID};
